<script></script>

<div class="extraCards">

    <div class="top_right_cards">

        <div class="first_cardContainer">
            <div class="chat-bubble first_card left">
                <div>
                    <div class="helper">
                        Excelência
                    </div>
                </div>
            </div>
        </div>
        <div class="second_cardContainer">
            <div class="chat-bubble second_card">
                <div>
                    <div class="helper">
                        Valor
                    </div>
                </div>
            </div>
        </div>
        <div class="third_cardContainer">
            <div class="chat-bubble third_card dark">
                <div>
                    <div class="helper">
                        #JEITOVLGI
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="bottom_right_cards">

        <div class="first_cardContainer">
            <div class="chat-bubble first_card left">
                <div>
                    <div class="helper">
                        Foco
                    </div>
                </div>
            </div>
        </div>
        <div class="second_cardContainer">
            <div class="chat-bubble second_card dark">
                <div>
                    <div class="helper">
                        Comprometimento
                    </div>
                </div>
            </div>
        </div>
        <div class="third_cardContainer">
            <div class="chat-bubble third_card left">
                <div>
                    <div class="helper">
                        Garra
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="bottom_left_cards">

        <div class="first_cardContainer">
            <div class="chat-bubble first_card dark">
                <div>
                    <div class="helper">
                        Qualidade
                    </div>
                </div>
            </div>
        </div>
        <div class="second_cardContainer">
            <div class="chat-bubble second_card left">
                <div>
                    <div class="helper">
                        Lealdade
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>



<style lang="scss">
@use "../styles/variables" as v;


.extraCards{
    position: relative;
    display: none;
}

.chat-bubble{

  --border-color: black;
  --background-color: white;
    $border-thickness: 2px;

    position: relative;
    color: black;
    border: #{$border-thickness} solid var(--border-color);
    border-radius: 999px 999px 0 999px;
    font-weight: 400;
    font-size: 0.86rem;
    text-align: center;
    padding: 0.3em 1em;
    text-transform: uppercase;
    background-color: var(--background-color);

    $half-height: 0.5em;
    $half-width: 1em;

    &::after { 
        content: '';
        position: absolute;
        bottom: -$half-height;
        right: 0;
        border-width: $half-height $half-width;
        border-style: solid;
        border-color: transparent var(--background-color) transparent transparent;
    }

    &::before { 
        $border-half-height: calc(0.5 * #{$border-thickness} + #{$half-height});
        $border-half-width: calc(#{$border-thickness} + #{$half-width});
        content: '';
        position: absolute;
        bottom: calc(-1 * #{$border-half-height} - #{$border-thickness});
        right: calc(-1 * #{$border-thickness});
        border-width: $border-half-height $border-half-width;
        border-style: solid;
        border-color: transparent var(--border-color) transparent transparent;
    }
    &.dark {
        --border-color: #333333;
        --background-color: #333333;
        color: white;
    }


    &.left {
        border-radius: 999px 999px 999px 0;
    &::after { 
        left: 0;
        right: unset;
        border-color: transparent transparent transparent var(--background-color);
    }
    &::before { 
        left: calc(-1 * #{$border-thickness});
        right: unset;
        border-color: transparent transparent transparent var(--border-color);
    }
    }
}

.top_right_cards{
    position: absolute;
    width: 12.5em;
    top: 4em;
    right: 5em;

    .first_cardContainer{
        width: fit-content;
        margin-right: auto;
    }

           
    .second_cardContainer{
        width: fit-content;
        margin-left: auto;
        padding-top: 1em;
    }
           

    .third_cardContainer{
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 1em;
    }
   

}

.bottom_right_cards{
    position: absolute;
    width: 15em;
    top: 75em;
    right: 2em;

    .first_cardContainer{
        width: fit-content;
        margin-right: auto;
    }

           
    .second_cardContainer{
        width: fit-content;
        margin-left: auto;
        padding-top: 1em;
    }
           

    .third_cardContainer{
        width: fit-content;
        padding-left: 2em;
        padding-top: 1em;
    }
   

}

.bottom_left_cards{
    position: absolute;
    width: 11em;
    top: 68em;
    left: 4em;

    .first_cardContainer{
        width: fit-content;
        margin-left: auto;
    }

    .second_cardContainer{
        width: fit-content;
        margin-right: auto;
        padding-top: 1em;
    }
           
}

@media only screen and (min-width: v.$md-desktop-devices) {
   
    .extraCards{
        display: block;
    }

}

</style>